import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ChartsModule } from 'ng2-charts';

import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MonitoringComponent } from './monitoring.component';
import { MonitoringFiltersComponent } from './monitoring-filters/monitoring-filters.component';
import { MonitoringFiltersSelectDateComponent } from './monitoring-filters/monitoring-filters-select-date/monitoring-filters-select-date.component';
import { MonitoringFiltersSelectMultiComponent } from './monitoring-filters/monitoring-filters-select-multi/monitoring-filters-select-multi.component';
import { MonitoringGraphBarHorizontalComponent } from './graphs/monitoring-graph-bar-horizontal/monitoring-graph-bar-horizontal.component';
import { MonitoringGraphBarVerticalComponent } from './graphs/monitoring-graph-bar-vertical/monitoring-graph-bar-vertical.component';
import { MonitoringGraphDoughnutComponent } from './graphs/monitoring-graph-doughnut/monitoring-graph-doughnut.component';
import { MonitoringGraphPieComponent } from './graphs/monitoring-graph-pie/monitoring-graph-pie.component';
import { MonitoringGraphRadarComponent } from './graphs/monitoring-graph-radar/monitoring-graph-radar.component';
import { MonitoringGraphTableComponent } from './graphs/monitoring-graph-table/monitoring-graph-table.component';
import { MonitoringGraphDayComponent } from './graphs/monitoring-graph-day/monitoring-graph-day.component';
import { MonitoringResultsComponent } from './monitoring-results/monitoring-results.component';
import { MonitoringResultsGraphComponent } from './monitoring-results/monitoring-results-graph/monitoring-results-graph.component';
import { MonitoringResultsPrintComponent } from './monitoring-results/monitoring-results-print/monitoring-results-print.component';
import { MonitoringGraphModalComponent } from './graphs/monitoring-graph-modal/monitoring-graph-modal.component';
import { MonitoringResultsUsersComponent } from './monitoring-results/monitoring-results-users/monitoring-results-users.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MatNativeDateModule,
        MatSliderModule,
        MatDatepickerModule,
        MatTableModule,
        MatFormFieldModule,
        ChartsModule
    ],
    exports: [
        MonitoringComponent
    ],
    declarations: [
        MonitoringComponent,
        MonitoringFiltersComponent,
        MonitoringFiltersSelectDateComponent,
        MonitoringFiltersSelectMultiComponent,
        MonitoringGraphBarHorizontalComponent,
        MonitoringGraphBarVerticalComponent,
        MonitoringGraphDoughnutComponent,
        MonitoringGraphPieComponent,
        MonitoringGraphRadarComponent,
        MonitoringGraphTableComponent,
        MonitoringGraphDayComponent,
        MonitoringResultsComponent,
        MonitoringResultsGraphComponent,
        MonitoringResultsPrintComponent,
        MonitoringGraphModalComponent,
        MonitoringResultsUsersComponent
    ],
    providers: [
        MatNativeDateModule,
        {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'}
    ]
})
export class MonitoringModule {}
